import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import PedidoDetalhesViewModel from "@/shared/view-models/PedidoDetalhesViewModel";
import GerarNovoPedidoCaracteristicasViewModel from "@/shared/view-models/GerarNovoPedidoCaracteristicasViewModel";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import novaEmbalagemViewModel from "@/shared/view-models/Filtros/NovaEmbalagemViewModel";
import Tools from "@/shared/services/tools";

const name = 'PedidoEmAndamentoPDF'
export default {
    name,
    components:{
      "g-button": gButton,
      "g-card": gCard,
      "g-pdf": gPdf,
    },
    props: {
      pedidoSelecionado: {
          type: String,
          default: ''
        },
      PropcaminhoImagem:{
        type: String,
        default: ''
      },
      PropstyleImg: {
        type:String,
        default: ''
      }
    
    },
    mounted() {
      var pediId =  this.$route.params.id
      
      if(pediId) {
        this.PedidoId = pediId 
      } else {
        this.PedidoId = this.pedidoSelecionado 
      }

      this.getDetalhesDoPedido()
      this.GetParcelas()

      this.getTipoFluxoOrcamento()

      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

      var today = new Date();
      var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
      this.DiaHoje = year;
    },

    updated() {
      var pediId =  this.$route.params.id
      
      if(pediId) {
        this.PedidoId = pediId 
      } else {
        this.PedidoId = this.pedidoSelecionado 
      }

      this.getDetalhesDoPedido()
    },

    data() {
      return {
        PedidoId: null,
        detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
        novoPedidoDetalhes : new PedidoDetalhesViewModel(),
        novaEmbalagem : new novaEmbalagemViewModel(),
        caracteristicasPedido : new GerarNovoPedidoCaracteristicasViewModel(),
        embalagensArray:[],
        OrcamentoId: null,
        fsc: null,
        InformacaoOrcamentoComponenteArray:[],
        ComponentePedidoArray:[],
        executarvisualizacao: 0,
        linhaSelecionada: {},
        pdfdownload: false,
        pdfvisualizacao: false,
        renderiza: false,
        caminhoImagem: null,
        styleImg: null,
        parcelasInfo: [],
        componentesInfo: [],
        tipoFluxoOrcamento: null,
        DiaHoje: null,
      } 
    },

    methods: {
      formataDecimal(valor){
        return Tools.valorDecimalFormatado(valor)
      },
  
      formataMonetario(valor){ 
        return Tools.valorMonetario4Digitos(valor)
      },
      pdfFinal(){
        this.renderiza = true
        this.executarvisualizacao++

        var id = this.$route.params.id 
        
        if(id) {        
          this.PedidoId = id 
        } else {
          this.PedidoId = this.pedidoSelecionado
        }
      },

        getDetalhesDoPedido() {
            this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.PedidoId}`,
            })
              .then((response) => {
                Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
                this.getDetalhesGeraisDoPedido()
              })
              .catch(() => {
              });
          },
          getDetalhesGeraisDoPedido() {
            this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesGeraisDoPedidoFluxo/${this.PedidoId}`,
            })
              .then((response) => {
                Tools.objectCustomAssign(this.novoPedidoDetalhes, Tools.captalizeKeys(response.data.data))
                this.OrcamentoIdCerto = this.novoPedidoDetalhes.OrcamentoId;
                this.getCaracteristicasDoGerarNovoPedido()
              })
              .catch(() => {
              });
          },
          getCaracteristicasDoGerarNovoPedido() {
            this.$isLoading(true)
            this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Pedido/GetCaracPedidoFluxo/${this.PedidoId}`,
              data: {
                PedidoId: this.PedidoId,
              }
            })
              .then((response) => {
                Tools.objectCustomAssign(this.caracteristicasPedido, Tools.captalizeKeys(response.data.data))
                this.InformacoesOrcamentoComponenteByOrcamentoId()
              }).finally(() => this.$isLoading(false))
          },
          executaTermino(){
            this.$emit('termino')
        },  

        erro(e){
          if(e == undefined){
            this.caminhoImagem = require('@/assets/imgs/Ilustracao_Nenhuma_Img.svg')
            this.styleImg = 'width: 100px'
            this.executaTermino();
          }
        },

        RotaImagem(){
          OrcamentoController.GetRotaImagemProduto(this.PedidoId).requisicao
          .then(res => {
            const urlBase = window.location.host
            if(res.data.data === 'erro'){
              this.erro(undefined)
              return
            }
            this.caminhoImagem = `http://${urlBase}/${res.data.data}`;
            this.styleImg = 'width: 400px'
      
            this.executaTermino();
      
          })
        },

        getTipoFluxoOrcamento() {
          this.axios({
            method: "get",
            url:
              process.env.VUE_APP_WEB_API +
              `Orcamento/GetTipoFluxoOrcamento/${this.OrcamentoSelecionado}`,
          })
            .then((response) => {
              this.tipoFluxoOrcamento = response.data.data.tipoFluxoOrcamento;
              if (this.tipoFluxoOrcamento === 0) {
                this.temImagem = false;
              } else {
                this.temImagem = true;
              }
            })
            .catch(() => {});
        },

        GetParcelas() {
          this.axios({
            method: 'get',
            url: process.env.VUE_APP_WEB_API + `Pedido/GetParcelasPedidos/${this.PedidoId}`,
          })
            .then((response) => {
              this.parcelasInfo = response.data.data;
                // this.axios({
                //   method: 'get',
                //   url: process.env.VUE_APP_WEB_API + `Pedido/GetComponentesParcelasPedidos/${this.$route.params.id}`,
                // })
                //   .then((response) => {
                //     this.componentesInfo = response.data.data;
                //   })
                //   .catch(() => {
                //   });
            })
            .catch(() => {
            });
        },

        getComponentes() {
          this.axios({
            method: "get",
            url:
              process.env.VUE_APP_WEB_API +
              `Componente/GetComponentesByOrcamentoId/${this.OrcamentoSelecionado}`,
          })
            .then((response) => {
              this.componentesLista = response.data.data;
              if(response.data.data == [])
              {
                this.contemComponentes = false
              }
              else{
                this.componentesLista = response.data.data;
                this.contemComponentes = true
                if(response.data.data.length >= 2){
                    this.quebraComponente = true
                }
              }
              this.getInfosBasicas();
            })
            .catch(() => {});
        },

        InformacoesOrcamentoComponenteByOrcamentoId() {
          this.axios({
            method: 'get',
            url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.OrcamentoIdCerto}`,
          })
          .then((response) => {
            this.ComponentePedidoArray = response.data.data
            this.novaEmbalagem = response.data.data
            
            this.novaEmbalagem.forEach((r)=>{
              r.embalagens = []
              r.embalagemFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
              r.embalagemCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
              r.embalagemPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
              r.embalagemPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadePapelEmbrulho}`) : ''
              r.quantidadeOutros == null || 0  ? '' : r.embalagens.push(r.descricaoEmbalagemOutros == null || '' ? 'Outros -' : r.descricaoEmbalagemOutros + `${r.quantidadeOutros}`) 

        })
            this.ComponentePedidoArray.forEach((r)=>{
              r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
              return this.ColunaMedidas = r.ColunaMedidas
              })
              this.RotaImagem
              this.executaTermino()
        })

          .catch(() => {
          });
        },
    
        embalagensEspecificas(){
          this.novaEmbalagem.forEach((r)=>{
            r.embalagens = []
            r.embalagemEspecificaFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
            r.embalagemEspecificaCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
            r.embalagemEspecificaPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
            r.embalagemEspecificaPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadeOutros}`) : ''
      })
      },

    }
};